module.exports = __webpack_public_path__ + "static/media/userProfile.cf5669d9.svg";